import React, { useEffect, useState } from "react";
import { View, Image, StyleSheet } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import ImageDetailsComponent from "./ComponentDetalles";
import MenuDocument from "./ComponentMenuDocument.js";
import ComponentObservaciones from "./ComponentObservaciones.js";
import { FinishMOButton } from "./ComponentFinishMoButton.js";
import { updateTermMo } from "../../services/ConnectDataBase.js";
import { setLog } from "../../services/ConnectDataBase.js";
import { SCREEN_IDS } from "../FullComponent";
import {
  Card,
  Paragraph,
  Divider,
  Text,
  Subheading,
  Chip,
} from "react-native-paper";
import { setEFabrica } from "../../redux/reducers";
import { formatDate } from "../../services/Functions.js";
import { translateText } from "../../translations/translationService";
import { updateCommentAdded } from "../../services/ConnectDataBase.js";
import { MaterialIcons } from "@expo/vector-icons";
import { backgroundColor2 } from "../../constants/Constants.js";
import { BACKGROUND_COLORS, TEXT_COLORS, BORDER_COLORS, STATUS_COLORS, BRAND_COLORS } from "../../style/colors.js";
import { notify } from "../../services/ui/notify";

export const InfoComponent = ({ data, calidad }) => {
  const dispatch = useDispatch();
  const eFabrica = data.eFabrica;
  const [cantidadTerminada, setCantidadTerminada] = useState(
    data.cantidad_terminada !== null && data.cantidad_terminada !== undefined
      ? Number(data.cantidad_terminada).toFixed(1)
      : Number(data.cantidad).toFixed(1)
  );
  const name = useSelector((state) => state.user.name);
  const cantidadOriginal = Number(data.cantidad ?? 0);
  const cantTerm = Number(cantidadTerminada ?? 0);
  const pendiente = (cantidadOriginal - cantTerm).toFixed(1);
  const [startsWithX, setStartsWithX] = useState(false);
  const lang = useSelector((state) => state.lang.value);
  const [comment, setComment] = useState("");
  const equipo = useSelector((state) => state.user.team);
  let tzoffset = new Date().getTimezoneOffset() * 60000;
  let localISOTime = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);

  useEffect(() => {
    if (comment) {
      updateCommentAdded(
        SCREEN_IDS.GENERAL,
        "ComentarioGeneralMo",
        comment,
        data.MO
      );
    }
  }, [comment]);

  useEffect(() => {
    setCantidadTerminada(
      data.cantidad_terminada !== null && data.cantidad_terminada !== undefined
        ? Number(data.cantidad_terminada).toFixed(1)
        : Number(data.cantidad).toFixed(1)
    );
  }, [data.cantidad_terminada, data.cantidad]);

  useEffect(() => {
    if (eFabrica) {
      dispatch(setEFabrica(eFabrica));
      const piedras = eFabrica.filter((item) => item.tipo === "PIEDRAS");
      setStartsWithX(
        piedras.some((item) => item.codigo.toLowerCase().startsWith("x"))
      );
    }
  }, [eFabrica, dispatch]);

  const cantidad = data.cantidad ? Number(data.cantidad).toFixed(1) : "-";

  const finishMO = async () => {
    const result = await updateTermMo(
      SCREEN_IDS.GENERAL,
      "TerminarMO",
      data.MO
    );
    if (result.status === "success") {
      setLog(
        SCREEN_IDS.GENERAL,
        "LOG",
        "FinalizarOrden",
        "Usuario: " +
          name +
          " Inicio: " +
          localISOTime +
          " Referencia: " +
          data.MO
      );

      setCantidadTerminada(Number(data.cantidad).toFixed(1));
    } else {
      notify.error(result.message || "No se ha podido finalizar la MO.");
    }
  };

  return (
    <Card style={styles.card}>
      <Card.Content>
        <View style={styles.titleContainer}>
          <View style={styles.titleRow}>
            <Text style={styles.title}>
              {translateText("Información de Orden", lang)}
            </Text>

            {calidad && (
              <MaterialIcons
                name='check-circle'
                size={24}
                color={backgroundColor2}
                style={{ marginLeft: 15, alignSelf: "center" }}
              />
            )}
            {startsWithX && (
              <Chip style={styles.lgdChip}>
                <Text style={{ fontSize: 16, color: TEXT_COLORS.LIGHT }}>
                  {translateText("LGD", lang)}
                </Text>
              </Chip>
            )}
          </View>
          <View style={styles.actionButtons}>
            {[
              "IT",
              "Control de calidad",
              "Jefe de taller",
              "Dirección",
            ].includes(equipo) && <FinishMOButton finishMO={finishMO} />}
            <MenuDocument data={data} />
            <ImageDetailsComponent imageUrl={data.imgcalidad} mo={data} />
            <ComponentObservaciones
              onSave={(newComment) => setComment(newComment)}
            />
          </View>
        </View>

        <Divider style={styles.divider} />

        <Paragraph style={styles.paragraph}>
          <Subheading>{translateText("Referencia:", lang)}</Subheading>{" "}
          <Text style={styles.valueText}>
            {String(data.referencia)} - {String(data.descripcion)}
          </Text>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Subheading>{translateText("PO:", lang)}</Subheading>{" "}
          <Text style={styles.valueText}>{String(data.PO)} </Text>
          <Paragraph style={styles.paragraph}>
            {"  "}
            <Subheading>{translateText("MO:", lang)}</Subheading>{" "}
            <Text style={styles.valueText}>
              {String(data.MO ? data.MO : "No disponible")}
            </Text>
          </Paragraph>
        </Paragraph>
        <View style={styles.row}>
          <Paragraph style={styles.paragraph}>
            <Subheading>{translateText("Unidades:", lang)}</Subheading>{" "}
            <Text style={styles.valueText}>
              {String(cantidad ? cantidad : "No disponible")}
            </Text>
          </Paragraph>
          <Paragraph style={[styles.paragraph, styles.marginLeft]}>
            <Subheading>{translateText("Fabricada:", lang)}</Subheading>{" "}
            <Text style={styles.valueText}>{cantidadTerminada ?? "0"}</Text>
          </Paragraph>
          <Paragraph style={[styles.paragraph, styles.marginLeft]}>
            <Subheading>{translateText("Pendiente:", lang)}</Subheading>{" "}
            <Text style={styles.valueText}>
              {pendiente >= 0 ? pendiente : "0"}
            </Text>
          </Paragraph>
        </View>

        <Paragraph style={styles.paragraph}>
          <Subheading>{translateText("Fecha de entrega:", lang)}</Subheading>{" "}
          <Text style={styles.valueText}>
            {String(
              formatDate(data.fechaEntrega)
                ? formatDate(data.fechaEntrega)
                : "No disponible"
            )}
          </Text>
          <Paragraph style={styles.paragraph}>
            {"  "}
            <Subheading>{translateText("Tipo orden:", lang)}</Subheading>{" "}
            <Text style={styles.valueText}>
              {String(data.tipo_orden ? data.tipo_orden : "No disponible")}
            </Text>
          </Paragraph>
        </Paragraph>
        <Paragraph style={styles.paragraph}>
          <Paragraph style={styles.paragraph}>
            <Subheading>
              {translateText("Clasificación Cliente:", lang)}
            </Subheading>{" "}
            <Text style={styles.valueText}>
              {String(
                data.clasificacionCliente
                  ? data.clasificacionCliente
                  : "No disponible"
              )}
            </Text>
          </Paragraph>
          {"  "}
          <Subheading>{translateText("Observaciones:", lang)}</Subheading>{" "}
          <Text style={styles.valueText}>
            {String(data.observaciones ? data.observaciones : "No disponible")}
          </Text>
        </Paragraph>
        <View style={styles.row}>
          <Paragraph style={styles.paragraph}>
            <Subheading>{translateText("Stamping:", lang)}</Subheading>{" "}
            <Text style={styles.valueText}>
              {String(
                data.stamping
                  ? data.stamping
                  : translateText("No disponible", lang)
              )}
            </Text>
          </Paragraph>
          {data.imagen_stamping ? (
            <Image
              source={{ uri: data.imagen_stamping }}
              style={styles.image}
            />
          ) : null}
        </View>
      </Card.Content>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
                    backgroundColor: BACKGROUND_COLORS.SECONDARY,
    borderRadius: 15,
          borderColor: BORDER_COLORS.LIGHT,
    borderWidth: 1,
  },
  titleContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    maxHeight: 40,
  },
  titleRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  title: {
          color: TEXT_COLORS.PRIMARY,
    fontSize: 16,
  },
  subheading: {
          color: TEXT_COLORS.PRIMARY,
  },
  divider: {
    marginVertical: 5,
  },
  paragraph: {
          color: BRAND_COLORS.SECONDARY,
    marginBottom: 5,
  },
  valueText: {
          color: BRAND_COLORS.PRIMARY_DARK,
    fontSize: 16,
    fontWeight: "bold",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
  marginLeft: {
    marginLeft: 10,
  },
  image: {
    width: "10%",
    height: 35,
    marginLeft: 10,
    resizeMode: "contain",
    borderRadius: 8,
    borderWidth: 1,
          borderColor: BRAND_COLORS.SECONDARY,
    backgroundColor: "white",
    flexShrink: 1,
    alignSelf: "center",
  },
  lgdChip: {
          backgroundColor: STATUS_COLORS.SUCCESS,
    alignSelf: "center",
    marginLeft: 10,
    paddingVertical: 4,
    paddingHorizontal: 12,
    borderRadius: 15,
    fontSize: 15,
    flexDirection: "row",
    alignItems: "center",
  },
  actionButtons: {
    flexDirection: "row",
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 10,
  },
});
